Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var index_1 = require("../../index");

var WPGColumnsBlock = function WPGColumnsBlock(props) {
  var innerBlocks = props.innerBlocks;

  if (!Array.isArray(innerBlocks)) {
    console.warn('Columns should have innerBlocks');
    return null;
  }

  var cols = innerBlocks.length;
  var columns = innerBlocks.map(function (col, ci) {
    return React.createElement("div", {
      className: "wp-block-column ".concat(ci + 1, "-column")
    }, col.innerBlocks.map(function (block, bi) {
      return React.createElement(index_1.WPGBlock, {
        key: bi,
        block: block
      });
    }));
  });
  return React.createElement("div", {
    className: "wp-block-columns has-".concat(cols, "-columns")
  }, columns);
};

exports.default = WPGColumnsBlock;